/**
 * Derived from svg-path-properties@0.2.2 vendored by flubber@0.4.2 (MIT).
 * Adapted for dependency-free internal ESM use in anvil2.
 */

const NUMBER = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi;
const SEGMENT = /([astvzqmhlc])([^astvzqmhlc]*)/gi;
const LENGTH = {
  a: 7,
  c: 6,
  h: 1,
  l: 2,
  m: 2,
  q: 4,
  s: 4,
  t: 2,
  v: 1,
  z: 0,
} as const;

type Command = keyof typeof LENGTH;
type ParsedSegment = [string, ...number[]];

function parseValues(args: string) {
  const numbers = args.match(NUMBER);
  return numbers ? numbers.map(Number) : [];
}

export default function parse(path: string): ParsedSegment[] {
  const data: ParsedSegment[] = [];

  path.replace(SEGMENT, (_, commandArg: string, argsArg: string) => {
    let command = commandArg;
    const args = parseValues(argsArg);
    let type = command.toLowerCase() as Command;

    if (type === "m" && args.length > 2) {
      data.push([command, ...args.splice(0, 2)]);
      type = "l";
      command = command === "m" ? "l" : "L";
    }

    const expectedLength = LENGTH[type];

    if (expectedLength === 0) {
      if (args.length > 0) {
        throw new Error("malformed path data");
      }

      data.push([command]);
      return "";
    }

    while (args.length > 0) {
      if (args.length === expectedLength) {
        data.push([command, ...args]);
        return "";
      }

      if (args.length < expectedLength) {
        throw new Error("malformed path data");
      }

      data.push([command, ...args.splice(0, expectedLength)]);
    }

    throw new Error("malformed path data");
  });

  return data;
}
